<template>
  <qc-container title="提现管理">
    <div class="money-box">
      <div class="mb-title">
        <div class="mbt-name">余额</div>
        <div class="mbt-back" @click="toBankList">
          银行卡管理
        </div>
      </div>

      <div class="mb-content">
        <div class="mbc-money">
          <span class="mbc-unit">￥</span>
          <div class="mbc-number">{{shopInfo.money}}</div>
        </div>
        <div class="mbc-but" @click="doWithdrawal">
          <div>
            提现
          </div>
        </div>
      </div>
    </div>

    <div class="table-box">
      <page-request @load="loadData" ref="table" url="/api/mgr/business/shop/money/info/incomeList" :table-header="tableHeader" :expend="expend" :prop="{goodsType:0}" :op-width="200">
        <div v-if="totalRecord > 0">
          共{{totalRecord}}笔 | 进行中{{incomeSum.progressMoney}}元   成功{{incomeSum.incomeMoney}}元   失败{{incomeSum.outMoney}}元
        </div>
      </page-request>
    </div>

    <withdrawal-add ref="withdrawalAdd" @success="withdrawalSuccess"></withdrawal-add>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import WithdrawalAdd from "@org/finance/op/withdrawal-add.vue";

export default {
  name: "",
  components: {WithdrawalAdd, PageRequest, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "createTime", label: "发生日期",width:160},
        {prop: "money", label: "提现金额（元）",width:160},
        {prop: "commissionMoney", label: "手续费（元）",width:160},
        {prop: "actualMoney", label: "实际到账（元）",width:160},
        {prop: "code", label: "流水号",width:200},
        {type: "bank", label: "银行卡",width:200},
        {label: "类型",renderDraw:row=>{return row.status==0?"待审核": row.status==1?"成功":"失败";},width: 100},
        {prop: "errorMsg", label: "说明"}
      ],
      expend: [
        {label: "发生日期", start: "startTime", end: "endTime", type: "daterange"},
        {label: "类型", prop: "status",type:"select",options:[{"label":"待审核","value":"0"},{"label":"成功","value":"1"},{"label":"失败","value":"1"}]},
        {label: "流水号", prop: "code"},
      ],
      incomeSum:{incomeMoney:0,outMoney:0,progressMoney:0},
      totalRecord:0,
      shopInfo:{money:0}
    }
  },
  mixins: [tableBase],
  methods: {
    loadData(searchObj,data){
      console.log("=============查询条件================")
      console.log(searchObj,data);

      this.totalRecord = data.totalRecord;
      this.findMoneyLogSum(searchObj);
    },
    findMoneyLogSum(searchObj){
      this.simpleGet("/api/mgr/business/shop/money/info/incomeLogSum", searchObj, result => {
        this.incomeSum = result.data;
      })
    },
    findShopInfo(){
      this.simpleGet("/api/mgr/business/shop/info/detail", null, result => {
        this.shopInfo = result.data;
      })
    },
    toBankList(){
      this.toRouter("/index/org/finance/bankList")
    },
    doWithdrawal(){
      this.$refs.withdrawalAdd.openDrawer();
    },
    withdrawalSuccess(){
      this.$refs.table.loadData();
      this.findShopInfo();
    }
  },
  mounted() {
    this.findShopInfo();
  }
}
</script>

<style lang="less" scoped>
.money-box{
  background: #0071ef;
  color: #ffffff;
  .mb-title{
    padding: 10px;
    display: flex;
    justify-content: space-between;

    .mbt-back{
      cursor: pointer;
    }
  }

  .mb-content{
    padding: 10px 0 20px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .mbc-money{
      display: flex;
      align-items: center;
      .mbc-unit{
       font-size: 24px;
      }
      .mbc-number{
       font-size: 36px;
      }
    }

    .mbc-but{
      div{
        width: 100px;
        height: 36px;
        background: #ffffff;
        color: #0071ef;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      div:hover{
        color: #00a0e9;
      }
    }
  }
}

.table-box{
  margin-top: 20px;
}
</style>
